import React from 'react';
import { JsonLd } from 'react-schemaorg';

export type AgentsStructuredDataProps = {
  title: string;
  description: string;
  canonicalUrl: string;
  image: string;
  installs: string;
};

/** See https://schema.org/WebPage */
type WebPage = {
  ['@type']: 'WebPage';
  name: string;
  description: string;
  url: string;
  image: string;
  additionalProperty: Array<{
    ['@type']: 'PropertyValue';
    name: string;
    value: string;
  }>;
};

type WebPageSnippet = {
  ['@context']: 'https://schema.org/';
} & WebPage;

export const AgentsStructuredData = (props: AgentsStructuredDataProps) => {
  const { title, description, canonicalUrl, image, installs } = props;

  const webPage: WebPageSnippet = {
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    name: title,
    description,
    url: canonicalUrl,
    image,
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Total Installs',
        value: `${installs}+`,
      },
    ],
  };

  return <JsonLd item={webPage} />;
};
